export const CATALOG = '/catalog';
export const ROUTER_CATALOG_DH = `${CATALOG}/dh`;
export const ROUTER_CATALOG_DH_L1 = `${ROUTER_CATALOG_DH}/L1`;
export const ROUTER_CATALOG_DH_L3 = `${ROUTER_CATALOG_DH}/L3`;
export const ROUTER_CATALOG_IAM = `${CATALOG}/iam`;
export const ROUTER_CATALOG_VEHICLE = '/vehicle';
export const ROUTER_CATALOG_SEARCH = '/search';
export const ROUTER_CATALOG_DETAILS = '/details';
export const ROUTER_CATALOG_MAINTENANCE_PLAN = '/maintenance-plan';
export const ROUTER_CATALOG_TIRES = '/tires';
export const ROUTER_CATALOG_OTS = '/ots';
export const UNIVERSAL_PRODUCTS_LINK = '/universal-products';
export const ROUTER_UNIVERSAL_PRODUCTS = `${UNIVERSAL_PRODUCTS_LINK}`;
export const ROUTER_UNIVERSAL_PRODUCTS_DERIVED = `${ROUTER_UNIVERSAL_PRODUCTS}/N-21404`;
